// BS: Icon used only by the hidden testimonials block below — restore when re-enabled.
// import { Icon } from "@iconify/react";
import classes from "./CoachingPage.module.css";

const CONTACT_EMAIL = "tribalrunninggalway@gmail.com";

// BS: Testimonials kept commented in case the client wants them back later.
// const testimonials = [
//     {
//         name: "Serhii Sylenko",
//         title: "the best runner in the world",
//         quote: "Training with this team has been a game-changer for me. The coaches are knowledgeable, supportive, and truly care about their athletes' progress.",
//     },
//     {
//         name: "Serhii Sylenko",
//         title: "the best runner in the world",
//         quote: "Training with this team has been a game-changer for me. The coaches are knowledgeable, supportive, and truly care about their athletes' progress.",
//     },
//     {
//         name: "Serhii Sylenko",
//         title: "the best runner in the world",
//         quote: "Training with this team has been a game-changer for me. The coaches are knowledgeable, supportive, and truly care about their athletes' progress.",
//     },
//     {
//         name: "Serhii Sylenko",
//         title: "the best runner in the world",
//         quote: "Training with this team has been a game-changer for me. The coaches are knowledgeable, supportive, and truly care about their athletes' progress.",
//     },
// ];

const achievementGroups = [
    [
        "Male student, novice athlete who progressed from 23 mins to 16:20 5 km, more to come",
        "Female athlete who progressed from 25 mins to 19 mins 5 km",
        "Male international student, novice athlete who progressed from 47 mins to 40 mins 10 km in one season",
        "Club hurling player to run 16 mins 5 km",
    ],
    [
        '"Fit for life" Masters male to run 5 km under 20 mins',
        "Retiree female to run first Marathon, setting PBs in 5 & 10 km on the way",
        "Male who progressed from weight loss goals to sub 3 hour Marathon",
        "Retired GAA player to finish Marathon under 3 hours",
    ],
    [
        "All Ireland Intermediate Cross Country Champion",
        'Senior Male to win "Streets of Galway 8k"',
        "Senior athlete selected for Irish team for European Cross Country",
        "Masters Marathoner to National winning medalist at 200m",
    ],
    [
        "Backyard Ultra (BYU) podium finisher",
        '3.20 marathoner who went sub 3 hours and joined the "Backyard Ultra 100 miles" club in one season',
        "Masters male Marathon runner from 3:05:00 to 2:42:00",
        "Plus countless PBs and life changing fitness improvements.",
    ],
];

export default function CoachingPage() {
    return (
        <div className={classes.page}>
            <section className={classes.section}>
                <div className={classes.media}>
                    <img
                        src="/images/coaching-image1.jpeg"
                        alt="Tribal Running team members after a race"
                        className={`${classes.image} ${classes.imageTop}`}
                    />
                </div>
                <div className={classes.text}>
                    <h1 className={classes.title}>
                        Reach Your Running Goals with Personalized Coaching
                    </h1>
                    <p>
                        Tribal Running organises FREE group training sessions for people of all
                        fitness levels with a wide range of events and distances catered for.
                    </p>
                    <p>
                        For those unable to attend group training sessions, paid personalised
                        online training programmes are available, tailored to the individual
                        needs and structured in 3-month blocks.
                    </p>
                </div>
            </section>

            <section className={classes.section}>
                <div className={classes.text}>
                    <h2 className={classes.quoteHeading}>&ldquo;Run For Your Life&rdquo;</h2>
                    <p>
                        Free running sessions for adults led by highly qualified coaches every
                        Tuesday and Thursday. Meet at the Tennis Astro parking lot in Doughiska
                        park.
                    </p>
                    <p>
                        <a
                            href="https://maps.app.goo.gl/y2ydbvBMuNfT7Z6c6"
                            target="_blank"
                            rel="noreferrer"
                            className={classes.link}
                        >
                            https://maps.app.goo.gl/y2ydbvBMuNfT7Z6c6
                        </a>
                    </p>
                    <p>
                        In association with Merlin Woods Sports club, we work together to promote
                        an active lifestyle in the local community, guided by a positive and
                        inclusive approach.
                    </p>
                </div>
                <div className={classes.media}>
                    <img
                        src="/images/coaching-image2.jpeg"
                        alt="Tribal Running group training session"
                        className={classes.image}
                    />
                </div>
            </section>

            <section className={classes.cta}>
                <div>
                    <h2>Ready to take your running to the next level?</h2>
                    <p>Join our training group and start achieving your running goals today!</p>
                </div>
                <a href={`mailto:${CONTACT_EMAIL}`} className={classes.ctaButton}>
                    Contact the coach
                </a>
            </section>

            <section className={classes.section}>
                <div className={classes.media}>
                    <img
                        src="/images/coaching-image3.jpg"
                        alt="Runners at a Tribal Running race"
                        className={classes.image}
                    />
                </div>
                <div className={classes.text}>
                    <h2 className={classes.photoHeading}>Race Day Photos</h2>
                    <p>
                        Relive the moments from our latest races, browse the full photo
                        album from Tribal Running 5K @ The Trappers Inn, July 11th.
                    </p>
                    <a
                        href="https://flic.kr/s/aHBqjCZ8C7"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.ctaButton}
                    >
                        View Photo Album
                    </a>
                </div>
            </section>

            <section className={classes.achievements}>
                <h2 className={classes.achievementsHeading}>
                    Some of the achievements from the training group/training programme
                </h2>
                <div className={classes.achievementsGrid}>
                    {achievementGroups.map((group, index) => (
                        <div className={classes.achievementCard} key={index}>
                            <ul className={classes.achievementList}>
                                {group.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </section>

            {/* BS: Testimonials kept commented in case the client wants them back later.
            <section className={classes.testimonials}>
                {testimonials.map((testimonial, index) => (
                    <div className={classes.testimonialCard} key={index}>
                        <div className={classes.avatar}>
                            <Icon icon="mdi:account-circle" width={40} height={40} />
                        </div>
                        <div>
                            <p className={classes.testimonialName}>{testimonial.name}</p>
                            <p className={classes.testimonialTitle}>{testimonial.title}</p>
                            <p className={classes.testimonialQuote}>{testimonial.quote}</p>
                        </div>
                    </div>
                ))}
            </section>
            */}
        </div>
    );
}
